"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _LoadingIndicator = _interopRequireDefault(require("./LoadingIndicator"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const LoadingButton = ({
  onClick,
  text,
  imgSrc = null,
  isLoading = false,
  disabled = false,
  bgColor = 'transparent',
  ...otherProps
}) => {
  const [isInternalLoading, setIsInternalLoading] = (0, _react.useState)(false);
  const [isHovered, setIsHovered] = (0, _react.useState)(false);
  const isMounted = (0, _react.useRef)(true);
  (0, _react.useEffect)(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  function isLoadingNow() {
    return isLoading || isInternalLoading;
  }
  async function handleClick(e) {
    setIsInternalLoading(true);
    await onClick(e);
    if (isMounted.current) {
      setIsInternalLoading(false);
    }
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex items-center",
    children: [imgSrc ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "cursor-pointer",
      onClick: e => handleClick(e),
      onMouseEnter: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: imgSrc,
        className: `w-8 h-8 p-1 border border-white rounded-lg`,
        style: {
          backgroundColor: isHovered ? '#e5e7eb' /* bg-gray-200 */ : bgColor
        },
        alt: text
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      className: `${isLoadingNow() || disabled ? "bg-gray-400" : "bg-blue-500"} text-white py-2 px-4 rounded whitespace-nowrap`,
      onClick: e => handleClick(e),
      disabled: isLoadingNow() || disabled,
      ...otherProps,
      children: text
    }), isLoadingNow() && /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoadingIndicator.default, {})]
  });
};
var _default = exports.default = LoadingButton;